import { ofType, combineEpics} from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import chnlSvc from '../api/chnl/chnlService';
import profileSvc from '../api/profile/profileService';
import appLoaderConverter from '../convertor/appLoaderConverter';
import { RDX_SESSION_INIT, updateSession, RDX_SESSION_INIT_DONE, initSessionDone, RDX_OHB_SESSION_INIT } from '../redux/sessionAction';
import store from '../app/store';
import { valid } from '../api';
import { navigate } from '../redux/navAction';

const initSessionEpic = action$ => action$.pipe(
	ofType(RDX_SESSION_INIT),
	mergeMap (
		// @@WP-REACT: customize the init data step, it can be API or some logic
		// ...
		() => chnlSvc.retrieveEnvParam().pipe(
			map(
				envResp => {
					if (valid(envResp)) {
						const envData = {
							envParam: envResp.response.responseData
						};
						store.dispatch(updateSession(envData));
						return initSessionDone();
					} else {
						return {type: 'rdx/Done'};
					}
				}
			)
		)
	)
);

const initOHBSessionEpic = action$ => action$.pipe(
	ofType(RDX_OHB_SESSION_INIT),
	mergeMap (
		() => forkJoin(
			profileSvc.retrieveStaffProfile()
		).pipe(
			map(
				responseList => {
					if (valid(responseList[0])) {
						const staffProfileResp = appLoaderConverter.retrieveStaffProfileResponse(responseList[0].response);
						if (staffProfileResp) {
							store.dispatch(updateSession({
								staffFullName: staffProfileResp.staffFullName
							}));
						}
					}
					return {type: 'rdx/Done'};
				}
			)
		)
	)
);

const initSessionDoneEpic = (action$, state$) => action$.pipe(
	ofType(RDX_SESSION_INIT_DONE),
	map (
		() => {
			return navigate (state$.value.session.targetFunc);
		}
	)
);

export default combineEpics( initSessionEpic, initOHBSessionEpic, initSessionDoneEpic);
